module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3.2c58f9c7.webp";